export default __webpack_public_path__ + "static/media/Alisuq heartbeat Compressed Faster.4dc7802c.gif";